import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { SetSELECTED as SetVALIDATOR } from "../../../../../../services/redux/slices/diagnostics/laboratory/validator";
import { Categories } from "../../../../../../services/fakeDb";
import { useMemo, useState } from "react";
import { MDBBadge, MDBCollapseHeader, MDBIcon } from "mdbreact";
import SuppliesModal from "../../onboard/card/footer/preAnalytical";
import {
  capitalize,
  fullName,
  getAge,
  getGenderIcon,
  sourceColor,
} from "../../../../../../services/utilities";

// service ids of a task form: an array, an object keyed by them, or a single id
const packagesOf = ({ packages } = {}) =>
  packages && typeof packages === "object"
    ? Array.isArray(packages)
      ? packages
      : Object.keys(packages)
    : packages
      ? [packages]
      : [];

const Header = ({ deal, index, totalDeals }) => {
  const { maxPage, activePlatform } = useSelector(({ auth }) => auth),
    { activeCOLAPSE, activePage } = useSelector(({ validator }) => validator),
    [showAnalytical, setShowAnalytical] = useState(false),
    department =
      activePlatform?.department?.toLowerCase() === "radiology" ? "RAD" : "LAB",
    { customerId, category, source } = deal,
    history = useHistory(),
    dispatch = useDispatch(),
    categoryName =
      category === "wi"
        ? "Walkin"
        : Categories.find(({ abbr }) => abbr === category)?.name;

  // a task has no cart: its tests are the services of its forms
  const dealWithTests = useMemo(
    () => ({
      ...deal,
      cart: [
        {
          packages: Object.values(deal?.diagnostic || {}).flatMap((form) =>
            Array.isArray(form)
              ? form.flatMap((entry) => packagesOf(entry || {}))
              : packagesOf(form || {}),
          ),
        },
      ],
    }),
    [deal],
  );

  const displayIndex =totalDeals - ((activePage - 1) * maxPage + index);
  return (
    <div
      style={{
        backgroundColor:
          deal?.status !== "done" ? "rgba(246, 211, 135, 0.2)" : "",
      }}
    >
      <MDBCollapseHeader>
        {displayIndex}. {getGenderIcon(customerId?.isMale)}{" "}
        {fullName(customerId?.fullName)} |
        <span style={{ color: "blue" }}>{getAge(customerId?.dob)}</span>
        <MDBBadge color={sourceColor(categoryName)} className="mx-2">
          {categoryName}
        </MDBBadge>
        {source && (
          <MDBBadge color="warning" className="mr-2">
            {capitalize(source?.name)}
          </MDBBadge>
        )}
        <span
          style={{ fontSize: "22px", marginBottom: "-10px" }}
          title={`View the result history of ${fullName(customerId?.fullName)}`}
          onClick={() => {
            localStorage.setItem(`customerId`, JSON.stringify(customerId));

            history.push(
              `/frontdesk/diagnostics/reports?patient=${customerId?._id}`
            );
          }}
        >
          👀
        </span>
        <i
          onClick={() =>
            dispatch(
              SetVALIDATOR({
                deal,
                activeCOLAPSE: activeCOLAPSE === index ? -1 : index,
              })
            )
          }
          style={{ rotate: `${activeCOLAPSE === index ? 0 : 90}deg` }}
          className="fa fa-angle-down transition-all"
        />
        {/* reagents, cartridges... used on the tests of this patient;
            on the right, beside the arrow */}
        <button
          type="button"
          className="btn btn-sm btn-outline-primary z-depth-0 float-right my-0 mr-3 px-2 py-1"
          style={{ textTransform: "none" }}
          title="Dispense the analytical supplies (reagents, cartridges) used on this patient"
          onClick={(e) => {
            e.stopPropagation();
            setShowAnalytical(true);
          }}
        >
          <MDBIcon icon="flask" className="mr-1" /> Analytical
        </button>
        {deal?.ssx && (
          <div
            style={{
              fontSize: "1rem",
              marginBottom: "-10px",
              marginTop: "0.5rem",
            }}
          >
            <span className="grey-text">SSX:</span>
            <span style={{ color: "blue" }} className="ml-1">
              {capitalize(deal?.ssx)}
            </span>
          </div>
        )}
      </MDBCollapseHeader>
      <SuppliesModal
        show={showAnalytical}
        toggle={() => setShowAnalytical(false)}
        deal={dealWithTests}
        department={department}
        phase="analytical"
      />
    </div>
  );
};

export default Header;
